import gql from 'graphql-tag';

export default gql`
query getAdminAccountImageStorage($gid: Int!) {
  images(where: {group_id: {_eq: $gid}}) {
    image_id
    metadata
  }
}
`;
